import { createContext, Dispatch, SetStateAction } from "react";

import { SearchOrganizationsByEnum } from "@organization/models/Organization";

export interface ISearchOrganizationsContext {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  searchBy: SearchOrganizationsByEnum;
  setSearchBy: Dispatch<SetStateAction<SearchOrganizationsByEnum>>;
}

export const SearchOrganizationsContext =
  createContext<ISearchOrganizationsContext>({
    searchQuery: "",
    setSearchQuery: () => {},
    searchBy: SearchOrganizationsByEnum.ByName,
    setSearchBy: () => {}
  });
